/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Hero_Linkdiscord1Inputs */

const id_profile_hero_linkdiscord1 = /** @type {(inputs: Profile_Hero_Linkdiscord1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tautkan Discord`)
};

const ms_profile_hero_linkdiscord1 = /** @type {(inputs: Profile_Hero_Linkdiscord1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pautkan Discord`)
};

const da_profile_hero_linkdiscord1 = /** @type {(inputs: Profile_Hero_Linkdiscord1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link Discord`)
};

const de_profile_hero_linkdiscord1 = /** @type {(inputs: Profile_Hero_Linkdiscord1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discord verknüpfen`)
};

const en_us2_profile_hero_linkdiscord1 = /** @type {(inputs: Profile_Hero_Linkdiscord1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link Discord`)
};

const es_es2_profile_hero_linkdiscord1 = /** @type {(inputs: Profile_Hero_Linkdiscord1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vincular Discord`)
};

const es_mx2_profile_hero_linkdiscord1 = /** @type {(inputs: Profile_Hero_Linkdiscord1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vincular Discord`)
};

const fil_profile_hero_linkdiscord1 = /** @type {(inputs: Profile_Hero_Linkdiscord1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I-link ang Discord`)
};

const fr_profile_hero_linkdiscord1 = /** @type {(inputs: Profile_Hero_Linkdiscord1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lier Discord`)
};

const it_profile_hero_linkdiscord1 = /** @type {(inputs: Profile_Hero_Linkdiscord1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collega Discord`)
};

const hu_profile_hero_linkdiscord1 = /** @type {(inputs: Profile_Hero_Linkdiscord1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discord összekapcsolása`)
};

const nl_profile_hero_linkdiscord1 = /** @type {(inputs: Profile_Hero_Linkdiscord1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discord koppelen`)
};

const no_profile_hero_linkdiscord1 = /** @type {(inputs: Profile_Hero_Linkdiscord1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koble til Discord`)
};

const pl_profile_hero_linkdiscord1 = /** @type {(inputs: Profile_Hero_Linkdiscord1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Połącz Discorda`)
};

const pt_br2_profile_hero_linkdiscord1 = /** @type {(inputs: Profile_Hero_Linkdiscord1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ligação Discord`)
};

const pt_profile_hero_linkdiscord1 = /** @type {(inputs: Profile_Hero_Linkdiscord1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vincular Discord`)
};

const ro_profile_hero_linkdiscord1 = /** @type {(inputs: Profile_Hero_Linkdiscord1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leagă Discord`)
};

const fi_profile_hero_linkdiscord1 = /** @type {(inputs: Profile_Hero_Linkdiscord1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yhdistä Discord`)
};

const sv_profile_hero_linkdiscord1 = /** @type {(inputs: Profile_Hero_Linkdiscord1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Länka Discord`)
};

const vi_profile_hero_linkdiscord1 = /** @type {(inputs: Profile_Hero_Linkdiscord1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liên kết Discord`)
};

const tr_profile_hero_linkdiscord1 = /** @type {(inputs: Profile_Hero_Linkdiscord1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discord'u Bağla`)
};

const cs_profile_hero_linkdiscord1 = /** @type {(inputs: Profile_Hero_Linkdiscord1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Propojit Discord`)
};

const bg_profile_hero_linkdiscord1 = /** @type {(inputs: Profile_Hero_Linkdiscord1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Свързване на Discord`)
};

const ru_profile_hero_linkdiscord1 = /** @type {(inputs: Profile_Hero_Linkdiscord1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Привязать Discord`)
};

const uk_profile_hero_linkdiscord1 = /** @type {(inputs: Profile_Hero_Linkdiscord1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Прив'язати Discord`)
};

const ar_profile_hero_linkdiscord1 = /** @type {(inputs: Profile_Hero_Linkdiscord1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ربط Discord`)
};

const hi_profile_hero_linkdiscord1 = /** @type {(inputs: Profile_Hero_Linkdiscord1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discord लिंक करें`)
};

const th_profile_hero_linkdiscord1 = /** @type {(inputs: Profile_Hero_Linkdiscord1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เชื่อมต่อ Discord`)
};

const ja_profile_hero_linkdiscord1 = /** @type {(inputs: Profile_Hero_Linkdiscord1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discord と連携`)
};

const zh_cn2_profile_hero_linkdiscord1 = /** @type {(inputs: Profile_Hero_Linkdiscord1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`链接Discord`)
};

const zh_hant1_profile_hero_linkdiscord1 = /** @type {(inputs: Profile_Hero_Linkdiscord1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`連結Discord`)
};

const ko_profile_hero_linkdiscord1 = /** @type {(inputs: Profile_Hero_Linkdiscord1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discord 연결`)
};

/**
* | output |
* | --- |
* | "Link Discord" |
*
* @param {Profile_Hero_Linkdiscord1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_hero_linkdiscord1 = /** @type {((inputs?: Profile_Hero_Linkdiscord1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Hero_Linkdiscord1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_hero_linkdiscord1(inputs)
	if (locale === "ms") return ms_profile_hero_linkdiscord1(inputs)
	if (locale === "da") return da_profile_hero_linkdiscord1(inputs)
	if (locale === "de") return de_profile_hero_linkdiscord1(inputs)
	if (locale === "en-US") return en_us2_profile_hero_linkdiscord1(inputs)
	if (locale === "es-ES") return es_es2_profile_hero_linkdiscord1(inputs)
	if (locale === "es-MX") return es_mx2_profile_hero_linkdiscord1(inputs)
	if (locale === "fil") return fil_profile_hero_linkdiscord1(inputs)
	if (locale === "fr") return fr_profile_hero_linkdiscord1(inputs)
	if (locale === "it") return it_profile_hero_linkdiscord1(inputs)
	if (locale === "hu") return hu_profile_hero_linkdiscord1(inputs)
	if (locale === "nl") return nl_profile_hero_linkdiscord1(inputs)
	if (locale === "no") return no_profile_hero_linkdiscord1(inputs)
	if (locale === "pl") return pl_profile_hero_linkdiscord1(inputs)
	if (locale === "pt-BR") return pt_br2_profile_hero_linkdiscord1(inputs)
	if (locale === "pt") return pt_profile_hero_linkdiscord1(inputs)
	if (locale === "ro") return ro_profile_hero_linkdiscord1(inputs)
	if (locale === "fi") return fi_profile_hero_linkdiscord1(inputs)
	if (locale === "sv") return sv_profile_hero_linkdiscord1(inputs)
	if (locale === "vi") return vi_profile_hero_linkdiscord1(inputs)
	if (locale === "tr") return tr_profile_hero_linkdiscord1(inputs)
	if (locale === "cs") return cs_profile_hero_linkdiscord1(inputs)
	if (locale === "bg") return bg_profile_hero_linkdiscord1(inputs)
	if (locale === "ru") return ru_profile_hero_linkdiscord1(inputs)
	if (locale === "uk") return uk_profile_hero_linkdiscord1(inputs)
	if (locale === "ar") return ar_profile_hero_linkdiscord1(inputs)
	if (locale === "hi") return hi_profile_hero_linkdiscord1(inputs)
	if (locale === "th") return th_profile_hero_linkdiscord1(inputs)
	if (locale === "ja") return ja_profile_hero_linkdiscord1(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_hero_linkdiscord1(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_hero_linkdiscord1(inputs)
	return ko_profile_hero_linkdiscord1(inputs)
});
export { profile_hero_linkdiscord1 as "profile.hero.linkDiscord" }